import { Box, VStack } from '@chakra-ui/react';
import { useProfile } from 'hooks';

import { Spinner } from 'components';

import { Banner, UserDashboard } from './components';

const Dashboard = () => {
  const { data: profile, isLoading } = useProfile();

  return (
    <VStack w="100%" gap="4" mt="4" px={{ base: '4', md: 0 }}>
      <Banner />
      {isLoading && (
        <Box py={10}>
          <Spinner />
        </Box>
      )}
      {!isLoading && profile && <UserDashboard profile={profile} />}
    </VStack>
  );
};
export default Dashboard;
